export default function LoadingUI() {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(/landing/bg-gradient.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
      <div
        style={{
          width: "200px",
          height: "200px",
          backgroundImage: `url(/liquid-sphere.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          mixBlendMode: "multiply",
        }}></div>
      <p
        style={{
          fontFamily: "Hanken Grotesk, sans-serif",
          marginTop: "32px",
          fontSize: "16px",
          fontWeight: 600,
          textAlign: "center",
          opacity: 0.75,
          color: "#121212",
        }}>
        Loading
      </p>
    </div>
  );
}
